import { compose, setDisplayName, withState, withHandlers } from "recompose";

export default compose(
  setDisplayName("WithTabs"),
  withState("tab", "setTab", "1"),
  withHandlers({
    onSetTab: ({ setTab }) => tab => () => {
      setTab(tab);
    }
  })
);
